<template lang="html">
<div class="card mb-3">
    <div class="row g-0">
        <div class="col-auto">
            <div class="add-container position-absolute start-0">
                <input class="input-file position-absolute" type="file" accept="image/*" @change="filesChanged($event.target.name, $event.target.files)" />
                <button class="btn btn-icon btn-icon-only btn-primary ms-2 mt-2" type="button">
                    <i class="icon-12 bi-pencil"></i>
                </button>
            </div>
            <img :src="imageSrc" :alt="establishment.name" class="card-img card-img-horizontal sw-20 sw-lg-20" style="object-fit: contain !important;">
        </div>
        <div class="col h-100">
            <div class="card-body">
                <div class="row g-0 align-content-center">
                    <div class="col-12 col-md-7 d-flex flex-column mb-2 mb-md-0 position-static">
                        <span class="cta-3 text-primary mb-2">{{ establishment.name }}</span>

                        <div class="text-small text-muted text-truncate">
                            <a v-if="establishment.website" :href="establishment.website" target="_blank" class="me-2"><i class="icon-18 bi-globe"></i></a>
                            <a v-if="establishment.page_reseau_public" :href="establishment.page_reseau_public" target="_blank" class="me-2"><i class="icon-18 bi-facebook"></i></a>
                            <a v-if="establishment.page_reseau_public_2" :href="establishment.page_reseau_public_2" target="_blank" class="me-2"><i class="icon-18 bi-instagram"></i></a>
                        </div>
                    </div>

                    <div class="col-12 col-md-5 d-flex justify-content-md-end">
                        <button class="btn btn-icon btn-icon-only btn-outline-primary" data-bs-toggle="modal" data-bs-target="#log-modal" type="button">
                            <i class="icon-12 bi-key"></i>
                        </button>
                    </div>
                </div>
                <div class="row g-2 mt-3">
                    <div class="col-12 col-lg-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col sh-6 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-2 text-success">{{ establishment.nb_positive }} avis</div>
                                    </div>
                                </div>
                                <div class="text-muted small">Positifs par mois</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col sh-6 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-2 text-danger">{{ establishment.nb_negative }} avis</div>
                                    </div>
                                </div>
                                <div class="text-muted small">Négatifs par mois</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col sh-6 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-2 text-primary">{{ establishment.response_time }} jours</div>
                                    </div>
                                </div>
                                <div class="text-muted small">Avant réponse</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import settings from "@/settings.coffee";
import ESTABLISHMENT_UPDATE_LOGO from '@/gql/mutations/establishmentUpdateLogo.graphql';
import { gqlMutation } from '@/gqlClient.js';

export default {
  name: 'EstablishmentCard',
  components: {},
  props: {
    establishment: Object
  },
  data() {
    return {};
  },
  computed: {
    imageSrc() {
      let ret = '';
      if (this.establishment.logo && this.establishment.logo !== "") {
        ret = this.establishment.logo;
      }
      return settings.backendMediaUrl + ret;
    }
  },
  methods: {
    upload_call_back(img_data, img_name) {
      const uid = this.establishment.uid;
      return gqlMutation(ESTABLISHMENT_UPDATE_LOGO, { uid, img_data, img_name });
    },
    upload_image(image) {
      if (!image) {
        return;
      }
      const self = this;
      const reader = new FileReader();
      reader.onload = function(aImg) {
        self.upload_call_back(aImg.target.result, image.name);
      };
      reader.readAsDataURL(image);
    },
    filesChanged(arg, arg2, arg3) {
      const self = this;
      if (arg2[0].size < 2000000) {
        self.upload_image(arg2[0]);
      } else {
        self.$store.dispatch("notify", {
          level: "danger",
          text: "Cet image est trop lourde"
        });
      }
    }
  },
  mounted() {
    // rien à faire ici
  },
  beforeDestroy() {
    // rien à faire ici
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.input-file{
    opacity: 0.0;
    margin: .5rem;
    width: 32px;
    height: 32px;
    cursor:pointer;
}
</style>
